export default "__VITE_ASSET__920dcdb0__"